import { combineReducers } from 'redux';

import {
  ConnectedActionHandlerMap as accountInformationReducer,
  namespace as accountInformationNamespace,
} from './account-information/account-information.reducer';
import { adminReducer, namespace as adminNamespace } from './admin/admin.reducer';
import { combinedReducer as alertsReducer, namespace as alertsNamespace } from './alerts/alerts.reducer';
import { combinedReducer as batchesReducer, namespace as batchesNamespace } from './batches/batches.reducer';
import { reduce as bulkReducer, namespace as bulkNamespace } from './bulk/bulk.reducer';
import { reduce as carrierSharingReducer, namespace as carrierSharingNamespace } from './carrier-sharing/carrier-sharing.reducer';
import { ConnectedActionHandlerMap as countryReducer, namespace as countryNamespace } from './country/country.reducer';
import {
  ConnectedActionHandlerMap as createLabelContentReducer,
  namespace as createLabelContentNamespace,
} from './create-label-content/create-label-content.reducer';
import { csvImportReducer, namespace as csvImportNamespace } from './csv-import/csv-import.reducer';
import { reducer as cswReducer, namespace as cswNamespace } from './csw/csw.reducer';
import { combinedReducer as customersReducer, namespace as customersNamespace } from './customers/customers.reducer';
import { reduce as entitiesReducer, namespace as entitiesNamespace } from './entities/entities.reducer';
import { notificationHubReducer, namespace as notificationHubNamespace } from './notification-hub/notification-hub.reducer';
import { reduce as labelQue, namespace as labelQueNamespace } from '../store/label-que/label-que.reducer';
import {
  ConnectedActionHandlerMap as exportOrdersReducer,
  namespace as exportOrdersNamespace,
} from './export/orders/export-orders.reducer';
import {
  ConnectedActionHandlerMap as exportShipmentsReducer,
  namespace as exportShipmentsNamespace,
} from './export/shipments/export-shipments.reducer';
import { reduce as fillProvidersReducer, namespace as fillProvidersNamespace } from './fill-providers/fill-providers.reducer';
import { reduce as freightSettingsReducer, namespace as freightSettingsNamespace } from './freight-settings/freight-settings.reducer';
import { reduce as ltlReducer, namespace as ltlNamespace } from './ltl/ltl.reducer';
import { reduce as holdUntilReducer, namespace as holdUntilNamespace } from './hold-until/hold-until.reducer';
import { reduce as inventoryReducer, namespace as inventoryNamespace } from './inventory/inventory.reducer';
import { reducer as iorsReducer, namespace as iorsNamespace } from './iors/index.reducer';
import { ConnectedActionHandlerMap as jobPipelineReducer, namespace as jobPipelineNamespace } from './job-pipeline/job-pipeline.reducer';
import { reduce as labelsReducer, namespace as labelsNamespace } from './labels/labels.reducer';
import {
  ConnectedActionHandlerMap as markAsShippedReducer,
  namespace as markAsShippedNamespace,
} from './mark-as-shipped/mark-as-shipped.reducer';
import {
  ConnectedActionHandlerMap as oneTimeScaleReducer,
  namespace as oneTimeScaleNamespace,
} from './one-time-scale/one-time-scale.reducer';
import { optimisticUpdater } from './optimistic.update.reducer';
import { combinedReducer as ordersReducer, namespace as ordersNamespace } from './orders/orders.reducer';
import { ConnectedActionHandlerMap as pagingReducer, namespace as pagingNamespace } from './paging/paging.reducer';
import {
  ConnectedActionHandlerMap as printSettingsReducer,
  namespace as printSettingsNamespace,
} from './print-settings/print-settings.reducer';
import { ConnectedActionHandlerMap as printReducer, namespace as printNamespace } from './printing/print.reducer';
import { reduce as productsReducer, namespace as productsNamespace } from './products/products.reducer';
import { ConnectedActionHandlerMap as rateBrowserReducer, namespace as rateBrowserNamespace } from './rate-browser/rate-browser.reducer';
import { reducer as rateViewerReducer, namespace as rateViewerNamespace } from './rate-viewer/rate-viewer.reducer';
import { reduce as referenceDataReducer, namespace as referenceDataNamespace } from './reference-data/reference-data.reducer';
import { combinedReducer as returnsReducer, namespace as returnsNamespace } from './returns/returns.reducer';
import { ConnectedActionHandlerMap as scanToPrintReducer, namespace as scanNamespace } from './scan-to-print/scan-to-print.reducer';
import { reduce as sellerReducer } from './seller/seller.reducer';
import { namespace as sellerNamespace } from './seller/seller.reducer.metadata';
import {
  sellerRecommendationsReducer,
  namespace as sellerRecommendationsNamespace,
} from './seller-recommendations/seller-recommendations.reducer';
import { reducer as serviceLevelsReducer, namespace as serviceLevelsNamespace } from './service-levels/service-levels.reducer';
import { combinedReducer as shipmentsReducer, namespace as shipmentsNamespace } from './shipments/shipments.reducer';
import { shippyReducer, namespace as shippyNamespace } from './shippy/shippy.reducer';
import { ConnectedActionHandlerMap as ssconnectReducer, namespace as ssconnectNamespace } from './shipstation-connect/ss-connect.reducer';
import {
  ConnectedActionHandlerMap as sidebarErrorsAndWarningsReducer,
  namespace as sidebarErrorsAndWarningsNamespace,
} from './sidebar-errors-and-warnings/sidebar-errors-and-warnings.reducer';
import { reducer as taxIdentifiersReducer, namespace as taxIdentifiersNamespace } from './tax-identifiers/index.reducer';
import { reduce as userReducer, namespace as userNamespace } from './user/user.reducer';
import { ConnectedActionHandlerMap as v3OptOutReducer, namespace as v3OptOutNamespace } from './v3-opt-out/v3-opt-out.reducer';
import { featureFlagReducer, namespace as featureFlagNamespace } from '../feature-flags/redux/reducer';
import { scanToVerifyReducer, namespace as scanToVerifyNamespace } from '../scan/verify/store/scan-to-verify.reducer';
import { suppliesFromShopifyStore as suppliesReducer } from './supplies/supplies.reducer';
import { namespace as suppliesNamespace } from './supplies/supplies.reducer.metadata';
import { customsDocumentsReducer } from './customs-documents/customs-documents.reducer';
import { namespace as customsDocumentsNamespace } from './customs-documents/customs-documents.reducer.metadata';

export const createRootReducer = () =>
  combineReducers({
    [adminNamespace]: adminReducer,
    [alertsNamespace]: alertsReducer,
    [batchesNamespace]: batchesReducer,
    [sidebarErrorsAndWarningsNamespace]: sidebarErrorsAndWarningsReducer,
    [bulkNamespace]: bulkReducer,
    [createLabelContentNamespace]: createLabelContentReducer,
    [cswNamespace]: cswReducer,
    [customersNamespace]: customersReducer,
    [entitiesNamespace]: optimisticUpdater(entitiesReducer),
    [exportOrdersNamespace]: exportOrdersReducer,
    [exportShipmentsNamespace]: exportShipmentsReducer,
    [fillProvidersNamespace]: fillProvidersReducer,
    [freightSettingsNamespace]: freightSettingsReducer,
    [ltlNamespace]: ltlReducer,
    [holdUntilNamespace]: holdUntilReducer,
    [jobPipelineNamespace]: jobPipelineReducer,
    [labelQueNamespace]: labelQue,
    [labelsNamespace]: labelsReducer,
    [featureFlagNamespace]: featureFlagReducer,
    [markAsShippedNamespace]: markAsShippedReducer,
    [oneTimeScaleNamespace]: oneTimeScaleReducer,
    [ordersNamespace]: ordersReducer,
    [pagingNamespace]: pagingReducer,
    [productsNamespace]: productsReducer,
    [inventoryNamespace]: inventoryReducer,
    [printNamespace]: printReducer,
    [printSettingsNamespace]: printSettingsReducer,
    [rateBrowserNamespace]: rateBrowserReducer,
    [rateViewerNamespace]: rateViewerReducer,
    [referenceDataNamespace]: referenceDataReducer,
    [returnsNamespace]: returnsReducer,
    [sellerNamespace]: sellerReducer,
    [sellerRecommendationsNamespace]: sellerRecommendationsReducer,
    [shipmentsNamespace]: shipmentsReducer,
    [ssconnectNamespace]: ssconnectReducer,
    [userNamespace]: userReducer,
    [v3OptOutNamespace]: v3OptOutReducer,
    [scanNamespace]: scanToPrintReducer,
    [scanToVerifyNamespace]: scanToVerifyReducer,
    [taxIdentifiersNamespace]: taxIdentifiersReducer,
    [iorsNamespace]: iorsReducer,
    [carrierSharingNamespace]: carrierSharingReducer,
    [countryNamespace]: countryReducer,
    [csvImportNamespace]: csvImportReducer,
    [accountInformationNamespace]: accountInformationReducer,
    [shippyNamespace]: shippyReducer,
    [serviceLevelsNamespace]: serviceLevelsReducer,
    [notificationHubNamespace]: notificationHubReducer,
    [suppliesNamespace]: suppliesReducer,
    [customsDocumentsNamespace]: customsDocumentsReducer,
  });
